import { render, staticRenderFns } from "./seckill-detail.vue?vue&type=template&id=02d0b3e0&scoped=true"
import script from "./seckill-detail.vue?vue&type=script&lang=js"
export * from "./seckill-detail.vue?vue&type=script&lang=js"
import style0 from "./seckill-detail.vue?vue&type=style&index=0&id=02d0b3e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d0b3e0",
  null
  
)

export default component.exports